'use es6';

import EditorError from 'DesignData/models/validation/EditorError';
import { ERROR, WARNING, INFO, SUCCESS } from 'DesignData/enums/EditorErrorTypes';
/**
 * @typedef {CodeEditorError}
 * @property {EditorErrorTypes} type
 * @property {String}           message
 * @property {Number}           lineNumber
 * @property {Number}           column
 * @property {String}           evidence
 * @property {String}           rawMessage
 */

export default class CodeEditorError extends EditorError {
  static sorter({
    lineNumber: lineA,
    column: colA,
    type: typeA,
    sessionId: sessionIdA
  }, {
    lineNumber: lineB,
    column: colB,
    type: typeB,
    sessionId: sessionIdB
  }) {
    if (typeA !== typeB) {
      if (typeA === ERROR) return -1;
      if (typeB === ERROR) return 1;
      if (typeA === WARNING) return -1;
      if (typeB === WARNING) return 1;
      if (typeA === INFO) return -1;
      if (typeB === INFO) return 1;
      if (typeA === SUCCESS) return -1;
      if (typeB === SUCCESS) return 1;
    }

    if (sessionIdA > sessionIdB) return 1;
    if (sessionIdA < sessionIdB) return -1;
    if (lineA > lineB) return 1;
    if (lineA < lineB) return -1;
    if (colA > colB) return 1;
    if (colA < colB) return -1;
    return 0;
  }

  constructor(props) {
    return super(props);
  }

}
CodeEditorError.REQUIRED_FIELDS = [...EditorError.REQUIRED_FIELDS, // 'sessionId', custom widget buffer reducer needs to pass sessionId to getHublInCssOrJsWarnings()
'lineNumber', 'column', 'evidence', 'rawMessage'];